module.exports = __webpack_public_path__ + "img/icon_2.f09e5bc5.svg";